const getColorEvent = (date) => {
	let currentDate = new Date();
	let firstDayOfCurrentWeek = currentDate.getDate() - currentDate.getDay();
	let lastDayOfCurrentWeek = firstDayOfCurrentWeek + 6;
	let DateOfFirstWeekDay = new Date(currentDate.setDate(firstDayOfCurrentWeek));
	let DateOfLastWeekDay = new Date(currentDate.setDate(lastDayOfCurrentWeek));
	let eventDate = new Date(date);
	let backgroundColor = 'red';

	if (eventDate < DateOfFirstWeekDay) {
		backgroundColor = 'orange';
	}

	if (eventDate > DateOfLastWeekDay) {
		backgroundColor = '#3788d8';
	}
	return backgroundColor;
};

export { getColorEvent };
